import { html } from "lit-element";
import moment from "moment";
import "moment/src/locale/nl";

import { StofwareElement } from "@stofloos/core/base/sw-element";

class StofwareDate extends StofwareElement {
	render() {
		return html`
			${this.formatDate(this.date, this.format)}
		`;
	}

	static get properties() {
		return {
			date: String,
			format: String,
			language: String,
			timestamp: { type: Boolean }
		};
	}

	formatDate(date, format) {
		if (this.timestamp && date !== Number(date)) {
			date = Number(date);
		}

		if (date == "null") {
			return "-";
		}

		return moment(date).locale(this.language).format(format);
	}

	constructor() {
		super();
		this.language = "nl";
	}

	firstUpdated() {
		if (this.language) {
			moment.locale(this.language);
		}
	}

	updated(changedProperties) {
		if(changedProperties.has('format') && this.format === 'null') {
			this.format = "DD-MM-YYYY - HH:mm";
		}
	}
}

window.customElements.define("sw-date", StofwareDate);
